import request from "@/axios";

/** 分页获取升级弹窗策略列表 */
export const getUpgradePopupList = (params) => {
  return request({
    url: "/lebo-addition/web/jumpStrategy/page",
    method: "get",
    params
  });
};

/** 新增升级弹窗策略 */
export const addUpgradePopup = (data) => {
  return request({
    url: "/lebo-addition/web/jumpStrategy/save",
    method: "post",
    data
  });
};

/** 更新升级弹窗策略 */
export const updateUpgradePopup = (data) => {
  return request({
    url: "/lebo-addition/web/jumpStrategy/update",
    method: "post",
    data
  });
};

/** 删除升级弹窗策略（支持批量删除） */
export const deleteUpgradePopup = (ids) => {
  return request({
    url: "/lebo-addition/web/jumpStrategy/delete",
    method: "post",
    params: {
      ids: Array.isArray(ids) ? ids.join(',') : ids
    }
  });
};

/** 获取升级弹窗策略详情 */
export const getUpgradePopupDetail = (id) => {
  return request({
    url: `/lebo-addition/web/jumpStrategy/detail/${id}`,
    method: "get"
  });
};

/** 获取操作日志列表 */
export const getUpgradePopupLogList = (params) => {
  return request({
    url: `/lebo-addition/web/operationLog/page`,
    method: "get",
    params: {
      module: 2, // 2: 升级弹窗管理
      subjectId: params.subjectId,
      ...params
    }
  });
};

/** 获取应用跳转列表（用于关联跳转选择） */
export const getAppJumpOptions = () => {
  return request({
    url: "/lebo-addition/web/jumpConfig/list",
    method: "get"
  });
}; 